module.exports = __webpack_public_path__ + "img/echarts_block_bg@2x.3a5f4b68.png";